module.exports = __webpack_public_path__ + "img/tou1.0d3fc03a.jpg";